"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Device = exports.DeviceStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Device_UdiCarrier_1 = require("./RTTI_Device_UdiCarrier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_Device_DeviceName_1 = require("./RTTI_Device_DeviceName");
var RTTI_Device_Specialization_1 = require("./RTTI_Device_Specialization");
var RTTI_Device_Version_1 = require("./RTTI_Device_Version");
var RTTI_Device_Property_1 = require("./RTTI_Device_Property");
var RTTI_ContactPoint_1 = require("./RTTI_ContactPoint");
var RTTI_Annotation_1 = require("./RTTI_Annotation");
var DeviceStatusKind;
(function (DeviceStatusKind) {
    DeviceStatusKind["_active"] = "active";
    DeviceStatusKind["_inactive"] = "inactive";
    DeviceStatusKind["_enteredInError"] = "entered-in-error";
    DeviceStatusKind["_unknown"] = "unknown";
})(DeviceStatusKind = exports.DeviceStatusKind || (exports.DeviceStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Device = t.recursion('IDevice', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('Device')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            definition: RTTI_Reference_1.RTTI_Reference,
            udiCarrier: t.array(RTTI_Device_UdiCarrier_1.RTTI_Device_UdiCarrier),
            status: (0, EnumType_1.createEnumType)(DeviceStatusKind, 'DeviceStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            statusReason: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            distinctIdentifier: t.string,
            _distinctIdentifier: RTTI_Element_1.RTTI_Element,
            manufacturer: t.string,
            _manufacturer: RTTI_Element_1.RTTI_Element,
            manufactureDate: RTTI_dateTime_1.RTTI_dateTime,
            _manufactureDate: RTTI_Element_1.RTTI_Element,
            expirationDate: RTTI_dateTime_1.RTTI_dateTime,
            _expirationDate: RTTI_Element_1.RTTI_Element,
            lotNumber: t.string,
            _lotNumber: RTTI_Element_1.RTTI_Element,
            serialNumber: t.string,
            _serialNumber: RTTI_Element_1.RTTI_Element,
            deviceName: t.array(RTTI_Device_DeviceName_1.RTTI_Device_DeviceName),
            modelNumber: t.string,
            _modelNumber: RTTI_Element_1.RTTI_Element,
            partNumber: t.string,
            _partNumber: RTTI_Element_1.RTTI_Element,
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            specialization: t.array(RTTI_Device_Specialization_1.RTTI_Device_Specialization),
            version: t.array(RTTI_Device_Version_1.RTTI_Device_Version),
            property: t.array(RTTI_Device_Property_1.RTTI_Device_Property),
            patient: RTTI_Reference_1.RTTI_Reference,
            owner: RTTI_Reference_1.RTTI_Reference,
            contact: t.array(RTTI_ContactPoint_1.RTTI_ContactPoint),
            location: RTTI_Reference_1.RTTI_Reference,
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            note: t.array(RTTI_Annotation_1.RTTI_Annotation),
            safety: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            parent: RTTI_Reference_1.RTTI_Reference
        })
    ]);
});
//# sourceMappingURL=RTTI_Device.js.map